// src/TickerMobileSourceIcons.js
import React from "react";
import { toPersianDigits } from "../../utils/toPersianDigits";
import RetryLogoImage from "../media/RetryLogoImage";
import "./TickerMobileSourceIcons.css";

const MAX_VISIBLE_SOURCES = 7;

const TickerMobileSourceIcons = ({
  activeSources = [],
  favicons = {},
}) => {
  if (!activeSources.length) return null;

  const visibleSources = activeSources.slice(0, MAX_VISIBLE_SOURCES);
  const moreCount = activeSources.length - visibleSources.length;

  return (
    <div className="ticker-mobile-source-icons">
      <div className="ticker-mobile-source-icons-capsule">
        <span className="ticker-mobile-source-icons__label">
          {toPersianDigits(activeSources.length)} منبع انتخاب شده
        </span>

        <div className="ticker-mobile-source-icons__list">
          {visibleSources.map((source) => (
            <div
              key={source}
              className="ticker-mobile-source-icons__item"
              title={toPersianDigits(source)}
            >
              {favicons[source] ? (
                <RetryLogoImage
                  src={favicons[source]}
                  alt=""
                  className="ticker-mobile-source-icons__img"
                  fallbackText={source.charAt(0)}
                  loading="lazy"
                  decoding="async"
                />
              ) : (
                <span className="ticker-mobile-source-icons__default">
                  {source.charAt(0)}
                </span>
              )}
            </div>
          ))}

          {moreCount > 0 && (
            <div
              className="ticker-mobile-source-icons__item ticker-mobile-source-icons__more"
              title={`${toPersianDigits(moreCount)} منبع دیگر`}
            >
              {toPersianDigits(moreCount)}+
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TickerMobileSourceIcons;
